import {RootState} from '../reducer/index'
import {Criteria} from '../../../type/criteria/criteria'
import {IPagination} from '../../../type/paginated'
import {_API} from './_Action'
import { IEcoWatchState } from '../reducer/generic/ecoWatchReducer'

export const _ECOWATCH = (name: string) => ({
  INIT: `ECOWATCH_${name}_INIT`,
  UPDATE_CRITERIA: `ECOWATCH_${name}_UPDATE_CRITERIA`,
  UPDATE_OBJECT_CRITERIA: `ECOWATCH_${name}_UPDATE_OBJECT_CRITERIA`,
  UPDATE_CRITERIA_BY_FILTER: `ECOWATCH_${name}_UPDATE_CRITERIA_BY_FILTER`,
  ..._API(`ECOWATCH_${name}`)
})

/*
    tags is : PME / FPP (Points, Focus, Perspective) / Hebdo (Hebdo) 
*/
export class EcoWatchAction<T> {

  constructor(private name: string, private action: (c?: Criteria, tags?: string) => (dispatch, getState: () => RootState) => Promise<IPagination<T>>) {

  }

  updateCriteria = (name: string, value: any, tags: string) => (dispatch, getState: () => RootState) => {
    dispatch({type: _ECOWATCH(this.name).UPDATE_CRITERIA, name, value})
    return this.fetch(dispatch, getState, tags)
  }

  updateCriteriaByObject = (object: any, tags: string)  => (dispatch, getState: () => RootState) => {
    dispatch({type: _ECOWATCH(this.name).UPDATE_OBJECT_CRITERIA, object})
    return this.fetch(dispatch, getState, tags)
  }

  updateCriteriaByFilter = (obj: any, tags: string) => (dispatch, getState: () => RootState) => {
    dispatch({type: _ECOWATCH(this.name).UPDATE_CRITERIA_BY_FILTER, obj})
    return this.fetch(dispatch, getState, tags)
  }

  private fetch(dispatch, test: () => RootState, tags: string) {
    return this.action(this.getState(test).criteria, tags)(dispatch, test)
  }

  private getState(getState: () => RootState): IEcoWatchState<T> {
    return getState().ecoWatch[this.name] as IEcoWatchState<T>
  }
}



// WEBPACK FOOTER //
// ./src/core/redux/action/ecoWatchAction.ts